import {
  CreateOrganizationDto,
  ListResponse,
  OrganizationDto,
  UpdateOrganizationDto,
} from "@dialogics/shared/dto/types"
import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"

export const organizationApi = createApi({
  reducerPath: "organizationApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/organization" }),
  tagTypes: ["Organization"],
  endpoints: builder => ({
    getOrganizations: builder.query<ListResponse<OrganizationDto>, void>({
      query: params => ({
        url: `/list`,
        body: params,
        method: "POST",
      }),
      providesTags: result =>
        result
          ? [
              ...result.results.map(({ id }) => ({
                type: "Organization" as const,
                id,
              })),
              { type: "Organization", id: "LIST" },
            ]
          : [{ type: "Organization", id: "LIST" }],
    }),
    createOrganization: builder.mutation<OrganizationDto, CreateOrganizationDto>({
      query: data => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Organization", id: "LIST" }],
    }),
    updateOrganization: builder.mutation<OrganizationDto, { id: number } & UpdateOrganizationDto>({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: "Organization", id }],
    }),
  }),
})

export const { useGetOrganizationsQuery, useCreateOrganizationMutation, useUpdateOrganizationMutation } =
  organizationApi
